import { isRttsUseMock } from '../../../config/featureFlags';
import type {
  RttsAcquireRequest,
  RttsAcquireResult,
  RttsGateFields,
  RttsJobDetail,
} from '../types';
import {
  liveAcquireHighlight,
  liveGetHighlightJob,
  liveGetRttsGateFields,
  liveListRttsGames,
} from './rttsClient';
import {
  mockAcquireHighlight,
  mockGetRttsGateFields,
  mockListRttsGames,
} from './rttsMock';
import { mockGetHighlightJob } from './rttsMockJobs';

export {
  configureRttsMock,
  getRttsMockConfig,
  resetRttsMock,
  seedDeliveredFixtureJobs,
} from './rttsMock';

export { seedMockJob, clearMockJobs } from './rttsMockJobs';

/** List finished/archived games with RTTS gate fields (tab entry point). */
export function listRttsGames(leagueId: string): Promise<RttsGateFields[]> {
  return isRttsUseMock()
    ? mockListRttsGames(leagueId)
    : liveListRttsGames(leagueId);
}

/** Gate fields for a single archive (per-game button entry point). */
export function getRttsGateFields(
  leagueId: string,
  archiveId: string
): Promise<RttsGateFields> {
  return isRttsUseMock()
    ? mockGetRttsGateFields(leagueId, archiveId)
    : liveGetRttsGateFields(leagueId, archiveId);
}

/** Trigger highlight reel generation (initial only — re-run/force removed from product). */
export function acquireHighlight(
  leagueId: string,
  body: RttsAcquireRequest
): Promise<RttsAcquireResult> {
  return isRttsUseMock()
    ? mockAcquireHighlight(leagueId, body)
    : liveAcquireHighlight(leagueId, body);
}

/** Poll/fetch a highlight job (member payload only). */
export function getHighlightJob(
  leagueId: string,
  jobId: string
): Promise<RttsJobDetail> {
  return isRttsUseMock()
    ? mockGetHighlightJob(leagueId, jobId)
    : liveGetHighlightJob(leagueId, jobId);
}
